import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		width: 100%;
	}
`;
export const LabelArea = styled.div`
	width: 100%;
`;
export const ContentArea = styled.div`
	width: 100%;
`;

export const LabelText = styled.p`
	font-weight: bold;
	margin: 0;
`;
export const ContentText = styled.p`
	margin: 0;
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
